{
  "orderDetail": {
    "lifecycle": {
      "title": "Order Lifecycle",
      "timelineView": "Timeline View",
      "tableView": "Table View",
      "showAllEvents": "Show all events",
      "showMilestonesOnly": "Show milestones only",
      "event": "Event",
      "status": "Status",
      "milestone": "Milestone",
      "date": "Date",
      "user": "User",
      "projected": "Projected",
      "completed": "Completed",
      "customDetail": "Custom Step Detail",
      "document": "Document",
      "documents": "Documents",
      "reprojection": "Reprojection",
      "details": "Details",
      "reprojectionHistory": "Reprojection History",
      "modified": "Modified",
      "reason": "Reason",
      "from": "From",
      "to": "To",
      "reprojectButton": "Reproject",
      "manualUpload": "Manual Upload",
      "search": "Search",
      "searchPlaceholder": "Search events",
      "documentCount": "{{count}} docs",
      "expectedBy": "Expected by",
      "overdue": {
        "days": " days overdue",
        "day": " day overdue"
      },
      "doc": "doc",
      "docs": "docs",
      "orderReceived": "Order received",
      "sentToVendor": "Sent to vendor",
      "receivedFromVendor": "Received from vendor",
      "deliveredToClient": "Delivered to Client",
      "statusPending": "Pending",
      "statusInProgress": "In Progress",
      "eventStatus": "Event Status",
      "customStepDetail": "Custom Step Detail",
      "reprojectAction": "Reproject date",
      "reproject": {
        "title": "Reproject",
        "originalDate": "Original date",
        "newDate": "Reprojection date",
        "reason": "Reason",
        "comments": "Comments (optional)",
        "save": "Save",
        "cancel": "Cancel",
        "close": "Close",
        "reasonRequired": "Reason",
        "newDateRequired": "Reprojection date",
        "columns": {
          "date": "Date",
          "reason": "Reason",
          "from": "From",
          "to": "To",
          "createdBy": "Created by",
          "comments": "Comments"
        },
        "empty": "No reprojections yet."
      },
      "eventDetails": {
        "title": "Event Details",
        "name": "Event Name",
        "projectedDate": "Projected Date",
        "responsible": "Responsible",
        "completedDate": "Completed Date",
        "company": "Company",
        "status": "Status"
      },
      "associatedDocuments": {
        "title": "Associated Documents",
        "upload": "Upload Document",
        "columns": {
          "filename": "File Name",
          "docNumber": "Document #",
          "type": "Type",
          "source": "Source",
          "uploadedBy": "Uploaded By",
          "uploadDate": "Upload Date",
          "lastUpdate": "Last Update"
        },
        "empty": "No documents uploaded yet."
      }
    }
  }
}
